import { Component, OnInit, ViewChild } from '@angular/core';
import { MedicalFeeAmount } from 'src/app/model/medical-fee';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MedicalFeePaymentManualWizardService } from '../../../services/medical-fee/medical-fee-payment-manual-wizard.service';
import { MedicalFeeAmountComponent } from '../../controls/medical-fee/medical-fee-amount/medical-fee-amount.component';

@Component({
  selector: 'app-medical-fee-payment-manual-amount',
  templateUrl: './medical-fee-payment-manual-amount.component.html',
  styleUrls: ['./medical-fee-payment-manual-amount.component.css']
})
export class MedicalFeePaymentManualAmountComponent implements OnInit {

  medicalFeeAmount: MedicalFeeAmount;
  form: FormGroup;
  @ViewChild('medicalFeeAmount', {static: false}) medicalFeeAmountCtrl: MedicalFeeAmountComponent;

  constructor( private formBuilder: FormBuilder,
               private mfpWizardService: MedicalFeePaymentManualWizardService ) {

    this.form = this.formBuilder.group({
      MedicalFeeAmount : ['']
    });
  }

  ngOnInit() {

    this.reload();
    this.form.valueChanges
             .subscribe(( value ) => this.mfpWizardService
             .setMedicalFeeAmount( value.MedicalFeeAmount ));
  }

  public reload() {

    this.form.patchValue({
      MedicalFeeAmount : this.mfpWizardService.getMedicalFeeAmount()
    });
  }

  public isValid() {

     return this.medicalFeeAmountCtrl.isValid();
  }

}
